import type { ChatCompletionStream } from 'openai/lib/ChatCompletionStream';
import type { ChatCompletionStreamingRunner } from 'openai/lib/ChatCompletionStreamingRunner.mjs';
import { createContext } from 'react';

import type { ChatProviderMessage } from '../types';
import type { ChatSessionRef } from '#hooks/useChatSession';

export type MessageCallback<MessageType = ChatProviderMessage> = (
  message: MessageType,
  messages: ChatProviderMessage[],
  runner?: ChatCompletionStream,
) => void;

export interface ChatState<MessageType = ChatProviderMessage> {
  session?: ChatSessionRef;
  messages: MessageType[];
  streamingMessage: ChatCompletionStreamingRunner | null;
  setStreamingMessage: (streamingMessage: ChatCompletionStreamingRunner | null) => void;
  systemPrompts: string[];
  onMessage: (callback: MessageCallback<MessageType>) => () => void; // Returns cleanup function
  addMessage: (message: Partial<MessageType>) => void;
}

export const ChatContext = createContext<ChatState>({
  messages: [],
  streamingMessage: null,
  setStreamingMessage: () => {},
  systemPrompts: [],
  addMessage: () => {},
  onMessage: () => {
    return () => {};
  },
});
